module.exports = __webpack_public_path__ + "img/ltkwedding-1x.04dbe2f.jpg";